import { AnyAction, IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wfs3dLayersState } from "../../wfs3dLayers.reducer";

export const wfs3dFeatureHeightPartialReducer: IPartialReducer<Wfs3dLayersState> = (
    state: Wfs3dLayersState,
    action: AnyAction
) => {
    return {
        adjustedHeight: action.adjustedHeight,
        loading: true,
    };
};
